export default {
    init() {
        // JavaScript to be fired on the contact page
        let dropdown = $(".contact-subject select");

        /** Anchor link and dynamically populate dropdown **/
        $('a[href*="#"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                let subject = $(this).data("subject");

                if(subject.length) { // Update subject dropdown
                    dropdown.val(subject);
                }

                // e.preventDefault();
            }   
            
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// /Users/mishatrombley/Documents/Sites/aurora-institute/app/public/wp-content/themes/aurora-institute/resources/assets/scripts/routes/contact.js